import { Spin } from "antd";
import { TileListItemType } from "../../../Types/invoiceManagementTypes";

export const viewCardConstants = {
  CUSTOMERS: "Customers:",
  JOBS: "Jobs:",
  INVOICES: "Invoices:",
  TOP: "Top: ",
  REVENUE: "Revenue",
  COGS: "COGS",
  TRUCKING: "Trucking",
  MATERIAL: "Material",
  GROSS_PROFIT: "Gross Profit",
};

export const SEARCH_FIELD_NAME = "searchField";

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const downloadModalConst = {
  DOWNLOAD_CONFIRMATION_TITLE: "Invoice Details",
  DOWNLOAD_CONFIRMATION_MSG:
    "There are invoices that are not reviewed in this download, continue anyway?",
  CANCEL_AND_REVIEW: "Cancel & Review",
  WIDTH: "700px",
};

export const getViewCardrenderData = (record: TileListItemType) => {
  return [
    {
      outerSpan: 6,
      innerSpan: 12,
      values: [
        [
          viewCardConstants.CUSTOMERS,
          viewCardConstants.JOBS,
          viewCardConstants.INVOICES,
        ],
        [record?.meta?.customers, record?.meta?.jobs, record?.meta?.invoices],
        [
          record?.meta.topCustomer,
          record?.meta?.topJob,
          record?.meta?.topInvoice,
        ],
      ],
    },
    {
      outerSpan: 6,
      innerSpan: 8,
      label: [
        viewCardConstants.REVENUE,
        viewCardConstants.TRUCKING,
        viewCardConstants.MATERIAL,
      ],
      dataVal: [
        record?.revenue?.total,
        record?.revenue?.trucking?.value,
        record?.revenue?.material?.value,
      ],
      dataPercentage: [
        "",
        record?.revenue?.trucking?.share,
        record?.revenue?.material?.share,
      ],
    },
    {
      outerSpan: 6,
      innerSpan: 8,
      label: [
        viewCardConstants.COGS,
        viewCardConstants.TRUCKING,
        viewCardConstants.MATERIAL,
      ],
      dataVal: [
        record?.revenue?.cogs?.total,
        record?.revenue?.cogs?.trucking?.value,
        record?.revenue?.cogs?.material?.value,
      ],
      dataPercentage: [
        record?.revenue?.cogs?.share,
        record?.revenue?.cogs?.trucking?.share,
        record?.revenue?.cogs?.material?.share,
      ],
    },
    {
      outerSpan: 6,
      innerSpan: 8,
      label: [
        viewCardConstants.GROSS_PROFIT,
        viewCardConstants.TRUCKING,
        viewCardConstants.MATERIAL,
      ],
      dataVal: [
        record?.revenue?.grossProfit?.total,
        record?.revenue?.grossProfit?.trucking?.value,
        record?.revenue?.grossProfit?.material?.value,
      ],
      dataPercentage: [
        record?.revenue?.grossProfit?.share,
        record?.revenue?.grossProfit?.trucking?.share,
        record?.revenue?.grossProfit?.material?.share,
      ],
    },
  ];
};

export const getFallBack = (loading, searchApplied) => {
  switch (loading) {
    case true:
      return <Spin size={"large"} />;
  }

  switch (searchApplied) {
    case true:
      return <p>{"No Invoices Available"}</p>
    case false:
      return <p>{"No Invoices Found"}</p>
    default:
      return <p>{"No Invoices Available"}</p>
  }
};
